
const getCartData = async () => {
    const cartResponse = await fetch('/cart.js');
    const cartData = await cartResponse.json();
    console.log("🚀 ~ file: cart-terms-booster.js ~ line 33 ~ booster_2x.addEventListener ~ cartData", cartData)
    return cartData
}


const removeBoosterFromCart = async (isBoosterInCart) => {
    let removeFormData = new FormData();
    removeFormData.append('id', isBoosterInCart.variant_id);
    removeFormData.append('quantity', 0);
    const removeRequestOpts = {
        method: 'POST',
        headers: {
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: removeFormData
    };
    try {
        const response = await fetch('/cart/change.js', removeRequestOpts);
        const data = await response.json();
        console.log("🚀 ~ file: cart-terms-booster.js ~ line 76 ~ try ~ data", data)
        if (response.ok && typeof window.syncCartEntries === 'function') {
          await window.syncCartEntries();
        }
    } catch (error) {
        console.error('Error:', error);
    } finally {
        // window.location.href = '/cart';
    }
}


const addBoosterToCart = async (booster_variant_id, property_name, total_entries) => {
    let formData = new FormData();
    formData.append('quantity', 1);
    formData.append('id', booster_variant_id);

    let entriesValue = total_entries;
    const tierMultiplier = parseInt(window.theme?.entries?.customer_tier_multiplier, 10);
    if (!Number.isNaN(tierMultiplier) && tierMultiplier > 1) {
      const base = parseInt(String(total_entries).replace(/,/g, ''), 10);
      if (!Number.isNaN(base)) entriesValue = String(base * tierMultiplier);
    }
    formData.append(`properties[${property_name}]`, entriesValue)

    console.log('object :>> ', formData);

    const fetchRequestOpts = {
        method: 'POST',
        headers: {
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
    };


    try {
        const response = await fetch('/cart/add.js', fetchRequestOpts);
        const data = await response.json();
        console.log("🚀 ~ file: cart-terms-booster.js ~ line 76 ~ try ~ data", data)
        // const error = typeof data.description === 'string' ? data.description : data.message;
        // if (data.status) this.setErrorMsgState(error);
        if (response.ok && typeof window.syncCartEntries === 'function') {
          await window.syncCartEntries();
        }
    } catch (error) {
        console.error('Error:', error);
    } finally {
        window.location.href = '/cart';
    }

}


if (!customElements.get('boost-selector')) {
    class BoostSelector extends HTMLElement {
        constructor() {
            super();
            this.boosterButtons = this.querySelectorAll('.boost-button');
            this.boosterButtons.forEach(button => {
                button.addEventListener('click', this.handleButtonClick.bind(this));
            });
        }

        async handleButtonClick(e) {
            console.log('button clicked');
            let allButtons = this.querySelectorAll('.boost-button');
            allButtons.forEach(button => {
                button.classList.remove('active');
            });
            e.target.classList.add('active');
            e.target.setAttribute('disabled', true);

            let loadingSpinner = e.target.children[0];
            loadingSpinner.removeAttribute('hidden');

            let booster_variant_id = e.target.getAttribute('data-variant-id');
            let total_entry = e.target.getAttribute('data-entry');
            let property_name = window.theme.entries?.giveaway_name;
            console.log("🚀 ~ BoostSelector ~ handleButtonClick ~ property_name:", property_name)
            console.log("🚀 ~ handleButtonClick ~ booster_variant_id:", booster_variant_id)

            // get cart data
            const cartData = await getCartData();
            let isBoosterInCart;

            if (cartData.items.length > 0) {
                isBoosterInCart = cartData.items.find(item => item.product_type === 'booster');
            }

            if (isBoosterInCart && isBoosterInCart?.variant_id === booster_variant_id) return window.location.href = '/cart';

            if (isBoosterInCart && isBoosterInCart?.variant_id !== booster_variant_id) {
               await removeBoosterFromCart(isBoosterInCart)
            }

            await addBoosterToCart(booster_variant_id, property_name, total_entry)


        }
    }
    customElements.define('boost-selector', BoostSelector);
}